"use client"

import React from "react"

import { Button } from "@/shadcn/components/ui/button"
import { Card } from "@/shadcn/components/ui/card"
import { cn } from "@/lib/utils"

import { CARD, CARD_DESCRIPTION, CARD_TITLE, SM_BUTTON } from "./styles"

export default function DeleteAccountCard({
  onDelete,
}: {
  onDelete: () => void
}) {
  return (
    <Card className={CARD}>
      {/* Stacks on a phone. `flex-1` is `flex: 1 1 0%`, so with a `shrink-0`
          button beside it the text column had no width it was unwilling to
          give up: at 375px the button kept its ~150px and the text got ~120,
          breaking the title over two lines and the description over eight, in
          a column narrower than the button. `flex-wrap` alone cannot fix that
          - a row only wraps when an item cannot fit its BASIS - so the text
          block gets `basis-full` below `sm` and `sm:basis-0` from there. */}
      <div className="tw:flex tw:w-full tw:flex-wrap tw:items-center tw:gap-x-2 tw:gap-y-4 tw:p-4 tw:sm:gap-y-2">
        <div className="tw:flex tw:min-w-0 tw:shrink tw:grow tw:basis-full tw:flex-col tw:gap-1 tw:sm:basis-0">
          <p className={CARD_TITLE}>Delete account</p>
          <p className={CARD_DESCRIPTION}>
            Permanently delete your account, all your feeds, and all posting
            history. This cannot be undone.
          </p>
        </div>
        <Button
          type="button"
          variant="destructive"
          size="sm"
          className={cn(SM_BUTTON, "tw:shrink-0")}
          onClick={onDelete}
        >
          Delete account
        </Button>
      </div>
    </Card>
  )
}
